{
  "customer-form": {
    "field": {
      "available_points": "Points disponibles",
      "birthday": "Anniversaire",
      "black_listed": "Liste de blocage",
      "black_listed_hint": "Les clients figurant sur la liste de blocage ne peuvent plus réserver de rendez-vous en ligne",
      "communication_way": "Méthode de contact",
      "email": "Email",
      "phone_nr": "Numéro de téléphone",
      "name": "Nom",
      "new_point_balance": "Nouveau score",
      "note": "Note",
      "notification_subscribed": "Notification de publicité",
      "surname": "Nom de famille",
      "update_point_balance": "Modifier de (+/-) points"
    },
    "text": {
      "off": "OFF",
      "on": "ON"
    }
  }
}
